import Widgets from 'js-widget-hooks';
import $ from '../../../../../src/Resources/core/jsx/utils/jquery-global';

Widgets.register('user', function (elem) {
  const el = $(elem);

  $.get(
    el.data('url'), /**
     * @param {{id: string, image?: string, name: string, profileUrl: string, apps: {href: string, title:string}[]}} userData
     */
    function (userData) {
      const profile = el.find('.js-target--profile-link');
      const image = el.find('.js-target--image');
      const apps = el.find('.js-target--apps');

      profile.attr('href', userData.profileUrl);

      if (userData.image) {
        image.replaceWith(
          $(`<img 
                        title="${userData.name}"
                        src="${userData.image}" 
                        class="rounded-circle dropdown-toggle"
                        id="userDropdown" 
                        data-bs-toggle="dropdown" 
                        aria-expanded="false"
                        alt="User profile"
                      />`),
        );
      }

      userData.apps.forEach(function (app) {
        apps.append(
          $(`<li><a class="dropdown-item" href="${app.href}" target="_blank">${app.title}</a></li>`),
        );
      });
    },
  );
});
